import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { CODIGO_CENTRUS, DESENVOLVIMENTO, SISTEMA_AREA_RESTRITA, SISTEMA_LOCAL } from '../../../app.constants';
import { CardsMenuService } from '../../card-menu/service/cards-menu.service';
import { AuthInterceptor } from '../../interceptor/auth.interceptor';
import * as ItemMenuActions from '../actions/item-menu.action';
import * as OperacacoItemMenuSistemaActions from '../actions/operacao-item-menu.action';
import * as SistemasListaActions from '../actions/sistemas-lista-agrupados.action';
import { TipoSistemaEnum } from '../dominios/enum/tipo-sistema.enum';
import { ItemMenu } from '../dominios/item-menu';
import { OperacaoItemMenuSistema } from '../dominios/operacao-item-menu-sistema';
import { SistemasLista } from '../dominios/sistemas-lista.modules';
import { StorafeUtil } from '../util/storasge.util';
import { PermissaoModulosService } from './permissoes-modulos.service ';

@Injectable()
export class ValidarPermissaoFuncionalidadeService {

  regra = 'manter'

  descricaoCard = new EventEmitter();
  // tslint:disable-next-line:member-ordering
  static atualiazarItemMenu = new EventEmitter<Boolean>();

  cdCentrus: number;

  operacaoItemMenuSistema$: Observable<OperacaoItemMenuSistema[]>;

  constructor(
    private permissaoModulosService: PermissaoModulosService,
    private authInterceptor: AuthInterceptor,
    private cardsMenuService: CardsMenuService,
    private router: Router,
    private store: Store<ItemMenu>,
  ) {
    this.operacaoItemMenuSistema$ = store.pipe(select('operacacoItemMenuSistema'));
  }


  getDadosSesseionStorage(): Number {
    const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);

    return (recuperandoObjeto)
      ? (this.cdCentrus = Number(recuperandoObjeto))
      : (this.cdCentrus = this.authInterceptor.getJwtCdCentrus())
  }

  async getItensMenuLateral() {
    const sistema = await this.permissaoModulosService.getSistemaByCdCentrusTpSistemaSgSistema(
      this.getDadosSesseionStorage(),
      TipoSistemaEnum.getId(DESENVOLVIMENTO),
      SISTEMA_AREA_RESTRITA
    )
    // const itens =  this.cardsMenuService.getCardsMenu();
    const itens = await this.permissaoModulosService
      .getItemMenuByCdCentrusAndIdSistema(this.getDadosSesseionStorage(), sistema.idSistema);

    return itens;

  }

  async getItemMenuPaiIdSistema() {
    const sistema = await this.permissaoModulosService.getSistemaByCdCentrusTpSistemaSgSistema(
      this.getDadosSesseionStorage(),
      TipoSistemaEnum.getId(DESENVOLVIMENTO),
      SISTEMA_AREA_RESTRITA)
    return await this.permissaoModulosService
      .getItemMenuPaiIdSistema(sistema.idSistema, this.authInterceptor.getJwtCdCentrus())
  }


  async getSistemaByCdCentrusTpSistemaSgSistema() {

    try {
      await this.permissaoModulosService.getSistemaByCdCentrusTpSistemaSgSistema(
        this.getDadosSesseionStorage(),
        TipoSistemaEnum.getId(DESENVOLVIMENTO),
        SISTEMA_AREA_RESTRITA
      ).then((sistema) => {
        this.getItensMenuUsuarioLogado(sistema);
        this.getListaSistemas();
        this.getOperadorItemMenuByCdCentrusAndIdSistema(sistema);
        StorafeUtil.gravaSessionStorage(SISTEMA_LOCAL, sistema.idSistema);
      })
    } catch (error) {

    }
  }

  async getListaSistemas() {
    const sistemasLista: SistemasLista[] = [];
    await this.permissaoModulosService.getListaSistemas(
      this.getDadosSesseionStorage(),
      TipoSistemaEnum.getId(DESENVOLVIMENTO))
      .then(arg => {
        arg.filter(item => {
          if (item.sgSistema.indexOf(SISTEMA_AREA_RESTRITA.toLowerCase()) === -1) {
            sistemasLista.push(<SistemasLista>{ nome: item.dsSistema, routerLink: item.dsUrl, icon: item.dsPath })
          }
        })
        this.store.dispatch(new SistemasListaActions.AddSistemasLista(sistemasLista));
      })
  }


  async getItensMenuUsuarioLogado(sistema) {

    if (sistema) {
      try {
        const itensMenu = await this.permissaoModulosService
          .getItemMenuByCdCentrusAndIdSistema(this.getDadosSesseionStorage(), sistema.idSistema);
        this.store.dispatch(new ItemMenuActions.AddItemMenu(itensMenu));
      } catch (error) {
        console.error(error);
      }
    }

  }


  async getOperadorItemMenuByCdCentrusAndIdSistema(sistema) {
    if (sistema) {
      try {
        const operacoesItemMenuSistemaLista = await this.permissaoModulosService
          .getOperadorItemMenuByCdCentrusAndIdSistema(sistema.idSistema, this.getDadosSesseionStorage());
        this.store.dispatch(new OperacacoItemMenuSistemaActions.AddOperacaoItemMenuSistema(operacoesItemMenuSistemaLista));
      } catch (error) {
        console.error(error);
      }
    }
  }

  public async pegarIdentificacaoPagina() {
    let retornoObjeto;
    const url = this.router.url.replace('/', ' ')


    try {
      retornoObjeto = await this.permissaoModulosService.getValidarPermissoesItemMenu(this.getDadosSesseionStorage(), url, this.regra);
    } catch (error) {
      retornoObjeto = false;
      console.error(error);
    }

    return retornoObjeto;
  }



}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/validar-permissao-funcionalidades.service.ts